export type SupervisiFarmasiHasil = "ya" | "tidak" | "na" | null;

export type SupervisiFarmasiKategori =
  | "pengelolaan-limbah"
  | "fasilitas-kebersihan"
  | "kepatuhan-petugas";

export interface SupervisiFarmasiItem {
  id: number;
  kategori: SupervisiFarmasiKategori;
  item_key: string;
  item_label: string;
  urutan: number;
  hasil: SupervisiFarmasiHasil;
  masalah: string | null;
  rekomendasi: string | null;
}

export interface UserRef {
  id: number;
  nama: string | null;
}

export interface SupervisiFarmasi {
  id: number;
  nomor_formulir: string | null;
  tanggal_supervisi: string;
  waktu_mulai: string | null;
  waktu_selesai: string | null;

  supervisor_user_id: number;
  supervisor: UserRef | null;
  supervisor_jabatan: string | null;
  signed_supervisor: boolean;
  signed_supervisor_at: string | null;

  kepala_unit_user_id: number | null;
  kepala_unit: UserRef | null;
  kepala_unit_nama_manual: string | null;
  signed_kepala_unit: boolean;
  signed_kepala_unit_at: string | null;

  temuan_utama: string | null;
  rencana_tindak_lanjut: string | null;

  is_locked: boolean;
  items?: SupervisiFarmasiItem[];

  created_at: string;
  updated_at: string;
}

export const KATEGORI_LABEL: Record<SupervisiFarmasiKategori, string> = {
  "pengelolaan-limbah": "I.  Supervisi Pengelolaan Limbah",
  "fasilitas-kebersihan": "II. Supervisi Fasilitas dan Kebersihan",
  "kepatuhan-petugas": "III. Kepatuhan Petugas dalam Hand Hygiene dan Penggunaan APD",
};
